import { intersection } from "lodash";
import { PROCESS_TAGS } from "utils/constants";

export const RESUME_SUBSCRIPTION_TAGS = [
  PROCESS_TAGS.CURRENT_SUBSCRIPTION,
  PROCESS_TAGS.ELECTRONIC_SIGNATURE_PENDING,
  PROCESS_TAGS.QUOTE_SENT,
  PROCESS_TAGS.SIGNED_INCOMPLETE,
];

const projectStatusTags = (project) =>
  (project && project.statuses ? project.statuses : [])
    .filter(({ status }) => status)
    .map(({ status: { tag } }) => tag);

export const shouldShowResumeSubscription = ({
  project,
  canUpdateSubscription,
  canManageProject,
}) => {
  if (!canManageProject || !canUpdateSubscription || project?.expired) {
    return false;
  }

  return (
    intersection(RESUME_SUBSCRIPTION_TAGS, projectStatusTags(project)).length >
    0
  );
};
